export type AccentKey = 'green' | 'gold';

export interface AccentTheme {
  dot: string;
  iconBox: string;
  badgeLight: string;
  text: string;
  border: string;
  strongBorder: string;
  solid: string;
  solidHover: string;
  line: string;
  softBg: string;
}

const green: AccentTheme = {
  dot: 'bg-accent-400',
  iconBox: 'bg-accent-100 text-accent-700',
  badgeLight: 'bg-accent-100 text-accent-900',
  text: 'text-accent-600',
  border: 'border-accent-200',
  strongBorder: 'border-accent-400',
  solid: 'bg-accent-500',
  solidHover: 'hover:bg-accent-400',
  line: 'bg-accent-300',
  softBg: 'bg-accent-50',
};

const gold: AccentTheme = {
  dot: 'bg-secondary-400',
  iconBox: 'bg-secondary-100 text-secondary-700',
  badgeLight: 'bg-secondary-100 text-secondary-900',
  text: 'text-secondary-600',
  border: 'border-secondary-200',
  strongBorder: 'border-secondary-400',
  solid: 'bg-secondary-500',
  solidHover: 'hover:bg-secondary-400',
  line: 'bg-secondary-300',
  softBg: 'bg-secondary-50',
};

const themes: Record<AccentKey, AccentTheme> = { green, gold };

export function accent(key: AccentKey): AccentTheme {
  return themes[key];
}